import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductionOrderService {
    private apiUrl = `${environment.apiUrl}/productionOrder`;

    constructor(private http: HttpClient) { }


    // Usando fetch para obter os pedidos
    getOrdersForProduction(startDate: Date, endDate?: Date): Observable<any> {
        let url = `${this.apiUrl}/orders?startDate=${startDate.toISOString()}`;
        if (endDate)
            url = `${url}&endDate=${endDate.toISOString()}`;

        return this.http.get(url, { observe: 'response' }).pipe(
            map(response => {
                if (response.status !== 200)
                    throw new Error('Erro ao buscar pedidos.');
                return response.body;
            })
        )
    }

    create(ordersId: any[], estimatedCompletionDate?: Date): Observable<any> {
        const url = `${this.apiUrl}`;
        const raw = JSON.stringify({
            ordersId,
            estimatedCompletionDate
        });
        return this.http.post(url, raw, {
                                            headers: { 'Content-Type': 'application/json' },
                                            observe: 'response'
                                        });

    }

}
